"use client";

import { c as _c } from "react/compiler-runtime";
import { Languages } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { useI18n } from "@llmgateway/i18n/react";
import type { Locale } from "@llmgateway/i18n";
interface LanguageSwitcherProps {
  className?: string;
}
export function LanguageSwitcher(t0) {
  const $ = _c(23);
  const {
    className
  } = t0;
  const {
    locale,
    locales,
    localeLabels,
    setLocale,
    t
  } = useI18n();
  let t1;
  if ($[0] !== setLocale) {
    t1 = value => setLocale(value as Locale);
    $[0] = setLocale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("language.label");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className) {
    t3 = cn("h-8 w-[124px] bg-background/80", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Languages className="h-3.5 w-3.5" />;
    t5 = <SelectValue />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3) {
    t6 = <SelectTrigger size="sm" aria-label={t2} className={t3}>{t4}{t5}</SelectTrigger>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== localeLabels || $[12] !== locales) {
    let t8;
    if ($[14] !== localeLabels) {
      t8 = item => <SelectItem key={item} value={item}>{localeLabels[item]}</SelectItem>;
      $[14] = localeLabels;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t7 = locales.map(t8);
    $[11] = localeLabels;
    $[12] = locales;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <SelectContent align="end">{t7}</SelectContent>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== locale || $[19] !== t1 || $[20] !== t6 || $[21] !== t8) {
    t9 = <Select value={locale} onValueChange={t1}>{t6}{t8}</Select>;
    $[18] = locale;
    $[19] = t1;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}